var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9577_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    stroke: "url(#paint0_linear_9577_28949)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9577_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8 40C47.9357 40 45.1886 41.1378 43.1633 43.1633C41.1378 45.1886 40 47.9357 40 50.8V101.2C40 104.064 41.1378 106.811 43.1633 108.837C45.1886 110.862 47.9357 112 50.8 112H83.2V94C83.2 91.1357 84.3378 88.3886 86.3633 86.3633C88.3886 84.3378 91.1357 83.2 94 83.2H112V50.8C112 47.9357 110.862 45.1886 108.837 43.1633C106.811 41.1378 104.064 40 101.2 40H50.8ZM95.0548 108.836C93.7606 110.13 92.159 111.074 90.4 111.579V94C90.4 93.0452 90.7793 92.1295 91.4544 91.4544C92.1295 90.7793 93.0452 90.4 94 90.4H111.579C111.074 92.159 110.13 93.7606 108.836 95.0548L95.0548 108.836ZM58 54.4C57.0452 54.4 56.1295 54.7793 55.4544 55.4544C54.7793 56.1295 54.4 57.0452 54.4 58C54.4 58.9548 54.7793 59.8705 55.4544 60.5456C56.1295 61.2207 57.0452 61.6 58 61.6H94C94.9548 61.6 95.8705 61.2207 96.5456 60.5456C97.2207 59.8705 97.6 58.9548 97.6 58C97.6 57.0452 97.2207 56.1295 96.5456 55.4544C95.8705 54.7793 94.9548 54.4 94 54.4H58ZM58 68.8C57.0452 68.8 56.1295 69.1793 55.4544 69.8544C54.7793 70.5295 54.4 71.4452 54.4 72.4C54.4 73.3548 54.7793 74.2705 55.4544 74.9456C56.1295 75.6207 57.0452 76 58 76H94C94.9548 76 95.8705 75.6207 96.5456 74.9456C97.2207 74.2705 97.6 73.3548 97.6 72.4C97.6 71.4452 97.2207 70.5295 96.5456 69.8544C95.8705 69.1793 94.9548 68.8 94 68.8H58ZM58 83.2C57.0452 83.2 56.1295 83.5793 55.4544 84.2544C54.7793 84.9295 54.4 85.8452 54.4 86.8C54.4 87.7548 54.7793 88.6705 55.4544 89.3456C56.1295 90.0207 57.0452 90.4 58 90.4H72.4C73.3548 90.4 74.2705 90.0207 74.9456 89.3456C75.6207 88.6705 76 87.7548 76 86.8C76 85.8452 75.6207 84.9295 74.9456 84.2544C74.2705 83.5793 73.3548 83.2 72.4 83.2H58Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9577_28949",
    x: 40,
    y: 40,
    width: 72,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9577_28949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9577_28949",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9577_28949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalCases);
export default __webpack_public_path__ + "static/media/Goal-Cases.39bf0e8a67a55467d7f32a7512985fab.svg";
export { ForwardRef as ReactComponent };